export type Fix = { lat: number; lon: number; accuracy: number };
export type LocateError = "denied" | "timeout" | "unavailable";

export const metres = (a: { lat: number; lon: number }, b: { lat: number; lon: number }) => {
  const x = ((b.lon - a.lon) * Math.PI) / 180 * Math.cos((a.lat * Math.PI) / 180);
  const y = ((b.lat - a.lat) * Math.PI) / 180;
  return Math.sqrt(x * x + y * y) * 6371000;
};

export const locate = (): Promise<Fix | { error: LocateError }> =>
  new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({ error: "unavailable" });
      return;
    }

    let best: GeolocationPosition | null = null;
    let settled = false;
    const done = (v: Fix | { error: LocateError }) => {
      if (settled) return;
      settled = true;
      navigator.geolocation.clearWatch(watch);
      resolve(v);
    };

    const watch = navigator.geolocation.watchPosition(
      (pos) => {
        if (!best || pos.coords.accuracy < best.coords.accuracy) best = pos;
      },
      (err) => {
        if (err.code === err.PERMISSION_DENIED) done({ error: "denied" });
      },
      { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 },
    );

    setTimeout(() => {
      if (best) {
        done({
          lat: best.coords.latitude,
          lon: best.coords.longitude,
          accuracy: best.coords.accuracy,
        });
      } else done({ error: "timeout" });
    }, 6000);
  });
